export const ArticleTypeNameEnum = {
    SERVICE_CARD_SERVICE: 'Inne usługi',
    SERVICE_CARD_ISSUE_HANDLE: 'Sprawy urzędowe',
    SERVICE_CARDS: 'Załatw sprawy urzędowe',
    WWW_ARTICLE: 'Inne treści',
};
